(() => {
  const syncRewards = (data) => {
    const incoming = data && data.node && data.node.querySelector('free-shipping-bar');
    if (!incoming) return;
    document.querySelectorAll('[data-zux-reward] free-shipping-bar').forEach(bar => {
      bar.replaceWith(incoming.cloneNode(true));
    });
  };
  customElements.whenDefined('cart-drawer').then(() => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.on === 'function') drawer.on('update-nodes', syncRewards);
  });
})();
